import {ManualPriceIncreasePreviewProps} from './manual-price-update.model';
import {useMemo} from 'react';
import {NumberHelper} from '../../helper/number-helper';
import {EvFormattedNumber} from '../components/ev-formatted-number';
import {EvDateFns} from '../components/ev-date-fns';

export function ManualPriceIncreasePreview(props: ManualPriceIncreasePreviewProps) {
  const prices = useMemo(() => {
    const percentParsed = NumberHelper.saveParseFloat(props.percentString) ?? 0;
    const singleOld = NumberHelper.saveParseFloat(props.price.single) ?? 0;
    const singleRounded = percentParsed > 0 ?
      Math.ceil(singleOld * ((percentParsed / 100) + 1) * 100) * 0.01 :
      singleOld;
    return {
      single: singleRounded,
      multi: singleRounded * (props.price.release ?? props.price.calc_quanity ?? 0),
    };
  }, [props.percentString]);

  return <>
    <div className="grid gap-2 grid-cols-8 text-right">
      <div className="col-span-4"></div>
      <div className="col-span-2 text-left">Preis Alt</div>
      <div className="col-span-2 text-left">Preis Neu</div>
      <div>Menge</div>
      <div>K-Menge</div>
      <div>Lose</div>
      <div>Datum</div>
      <div>Einzel</div>
      <div>Gesamt</div>
      <div>Einzel</div>
      <div>Gesamt</div>
      <div>{props.price.quanity}</div>
      <div>{props.price.calc_quanity}</div>
      <div>{props.price.lose}</div>
      <div><EvDateFns date={props.price.date} formatIn="iso" formatOut="dd.MM.yyyy"/></div>
      <div><EvFormattedNumber value={props.price.single} decimals={3} unit="€"/></div>
      <div><EvFormattedNumber value={props.price.multi} decimals={2} unit="€"/></div>
      <div><EvFormattedNumber value={prices.single} decimals={3} unit="€"/></div>
      <div><EvFormattedNumber value={prices.multi} decimals={2} unit="€"/></div>
    </div>
  </>;
}
